import { render, staticRenderFns } from "./pageDelete.vue?vue&type=template&id=665c69ba&"
import script from "./pageDelete.vue?vue&type=script&lang=ts&"
export * from "./pageDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports